import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';

const LoadError: React.FC = () => {
  return <T kind="Unable to load your learning collection" />;
};

export default observer(LoadError);
